import React from 'react';
import { GoogleLogin } from '@react-oauth/google';
import './Login.css';
import { useAuth } from '../AuthContext';
import { useNavigate, useLocation } from 'react-router-dom';

function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const from = location.state?.from?.pathname || '/links';
  const { token } = useAuth();

  React.useEffect(() => {
    if (token) {
      navigate(from, { replace: true });
    }
  }, [token, navigate, from]);

  const handleSuccess = (credentialResponse) => {
    // The credentialResponse.credential is the Google ID token.
    const token = credentialResponse.credential;
    login(token);
    // Navigate back to where the user attempted to go, or to the default page
    navigate(from, { replace: true });
  };

  const handleError = () => {
    console.error('Google Login Failed');
    alert('Login failed. Please try again.');
  };

  return (
    <div className="ls-login-root">
      <div className="ls-login-card">
        <div className="ls-logo">LS</div>
        <h1 className="ls-title">LuckyStars</h1>
        <p className="ls-subtitle">God Mode</p>
        <div className="ls-google">
          <GoogleLogin onSuccess={handleSuccess} onError={handleError} useOneTap />
        </div>
      </div>
    </div>
  );
}

export default Login;